module.exports = __webpack_public_path__ + "media/images/presta_busc/podologo-0ea0b5719d5e2f21283778a902c65d72.svg";